import React from 'react';
import { ThemeContext } from 'styled-components';
import HeaderDesktop from './header-desktop';
import HeaderMobile from './header-mobile';

export default function Header() {
  const { isMobile } = React.useContext(ThemeContext);

  return isMobile
    ? <HeaderMobile />
    : <HeaderDesktop />;
}
